const count = (field: string) => `COUNT(${field})` as const;

// TODO: interval type
// TODO: accept date instead of string ?
const timeBucket = (from: string, to: string, interval: string) => `TIME_BUCKET('${from}', '${to}', '${interval}')` as const;

// TODO: add interval types
const histogramBucket = (
  field: string,
  from: string,
  to: string,
  unit: number,
  interval: 'HOUR' | 'DAY' | 'WEEK' | 'MONTH' | 'MINUTE' | 'SECOND'
) => `HISTOGRAM_BUCKET(${field}, '${from}', '${to}', ${unit}, '${interval}')` as const;

// TODO: fallback type
const coalesce = (field: string, fallback: string) => `coalesce(${field}, ${fallback})` as const;

const explode = (field: string) => `explode(${field})` as const;

const objectKeys = (field: string) => `object_keys(${field})` as const;

export const aql = {
  count,
  timeBucket,
  histogramBucket,
  coalesce,
  explode,
  objectKeys,
};
